export const GRADE_LIST_START = 'GRADE_LIST_START';
export const GRADE_LIST_SUCCESS = 'GRADE_LIST_SUCCESS';
export const GRADE_LIST_ERROR = 'GRADE_LIST_ERROR';
export const PRINT_GRADE_LIST_START = 'PRINT_GRADE_LIST_START';
export const PRINT_GRADE_LIST_SUCCESS = 'PRINT_GRADE_LIST_SUCCESS';
export const PRINT_GRADE_LIST_ERROR = 'PRINT_GRADE_LIST_ERROR';
export const SET_SMA_DATA = 'SET_SMA_DATA';
export const SMA_RESET_ERRORS = 'SMA_RESET_ERRORS';
export const SMA_CHANGE_BASIS = 'SMA_CHANGE_BASIS';
export const SMA_GET_UDFS = 'SMA_GET_UDFS';
export const SMA_GET_UDFS_SUCCESS = 'SMA_GET_UDFS_SUCCESS';
export const SMA_GET_UDFS_ERROR = 'SMA_GET_UDFS_ERROR';

import apiClient from 'ps-components/lib/apiClient';

export function getGradeList(modelId, basis) {
  return async dispatch => {
    try {
      dispatch({ type: GRADE_LIST_START });
      const results = await apiClient.apiGet('/api/structure-modeling/analytics/grade-list/gradeList', {
        params: {
          modelId: modelId,
          basis
        }
      });
      dispatch({ type: GRADE_LIST_SUCCESS, payload: results });
    } catch (error) {
      dispatch({ type: GRADE_LIST_ERROR });
      throw error;
    }
  };
}

export function getMonetaryUDFs() {
  return async dispatch => {
    try {
      dispatch({ type: SMA_GET_UDFS });
      const results = await apiClient.apiGet('/api/structure-modeling/analytics/grade-list/getUDFs');
      dispatch({
        type: SMA_GET_UDFS_SUCCESS,
        udfList: results.data.udfFields.rows.map(udf => {
          return {
            label: udf.udfName,
            value: udf.udfField
          };
        })
      });
    } catch (error) {
      dispatch({ type: SMA_GET_UDFS_ERROR });
      throw error;
    }
  };
}

export function setBasis(basis) {
  return { type: SMA_CHANGE_BASIS, basis };
}

export function setSMAData(modelId) {
  return { type: SET_SMA_DATA, payload: { modelId } };
}

export function resetErrors() {
  return { type: SMA_RESET_ERRORS };
}

export function printGradeListPdf(modelId, basis, csrfPair, modelName, pdfHeader, pdfFooter) {
  return async dispatch => {
    const params = {
      modelId,
      modelName,
      basis,
      headerTemplate: pdfHeader,
      footerTemplate: pdfFooter
    };
    try {
      dispatch({ type: PRINT_GRADE_LIST_START });
      const results = await apiClient.apiPost('/api/util/report-print/printGradeList', params);
      if (results.data && results.data.success === true && results.data.fileUrl) {
        const fileUrl = results.data.fileUrl;
        window.location = `${fileUrl}&csrf_token=${csrfPair.csrf_token}&csrf_timestamp=${csrfPair.csrf_timestamp}`;
        dispatch({ type: PRINT_GRADE_LIST_SUCCESS });
      } else {
        dispatch({ type: PRINT_GRADE_LIST_ERROR });
      }
    } catch (error) {
      dispatch({ type: PRINT_GRADE_LIST_ERROR });
      throw error;
    }
  };
}
